import { type Common } from '../common.js';
import { type FindAllOptions, type Tag } from '../models/flow/tag.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/tags';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(queryParams?: FindAllOptions): Promise<Tag[]> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }
}
